import { cn } from "@/lib/utils"

interface UnreadBadgeProps {
  count: number
  className?: string
}

export function UnreadBadge({ count, className }: UnreadBadgeProps) {
  if (count <= 0) return null
  return (
    <div
      className={cn(
        "size-[20px] rounded-full bg-[var(--color-brand-terracotta)] flex items-center justify-center shrink-0",
        className,
      )}
    >
      <span className="text-[12px] font-semibold text-foreground leading-[20px]">
        {count > 99 ? "99+" : count}
      </span>
    </div>
  )
}
